/**
 * Slug de galerie : le contrat S2-g et l'API (`apps/api/src/console/schemas.ts`,
 * `MOTIF_SLUG_CONSOLE`) le fixent à 3-40 caractères, minuscules, chiffres et
 * tirets, ni tiret initial ni tiret final — c'est un sous-domaine public
 * (D11). Le front revalide la même forme pour éviter un aller-retour, mais
 * l'API reste l'autorité.
 */

export const LONGUEUR_MIN_SLUG = 3;
export const LONGUEUR_MAX_SLUG = 40;

/** Propose un slug à partir d'un nom de galerie : minuscules, tirets, sans accent. */
export function proposerSlug(nom: string): string {
  return nom
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, LONGUEUR_MAX_SLUG);
}

/** Un slug valide : minuscules, chiffres, tirets, ni au début ni à la fin. */
export const SLUG_VALIDE = /^[a-z0-9]+(-[a-z0-9]+)*$/;

/**
 * Slugs que la plateforme se réserve (`apps/api/src/console/schemas.ts`), dont
 * ceux du jeu de démonstration (`SLUGS_DEMO`, `apps/api/src/demo`).
 */
export const SLUGS_RESERVES: readonly string[] = [
  'app',
  'api',
  'console',
  'demo',
  'www',
  'conditions',
  'sainte-avoye',
  'maison-vallier',
  'studio-ravel',
  'kosei',
  'brun-et-fils',
  'nova-kunst',
];

export function slugValide(slug: string): boolean {
  return (
    slug.length >= LONGUEUR_MIN_SLUG &&
    slug.length <= LONGUEUR_MAX_SLUG &&
    SLUG_VALIDE.test(slug) &&
    !SLUGS_RESERVES.includes(slug)
  );
}

/** La forme seule d'un slug (longueur, caractères) : l'API dit s'il est libre ou réservé. */
export function formeSlugValide(slug: string): boolean {
  return (
    slug.length >= LONGUEUR_MIN_SLUG && slug.length <= LONGUEUR_MAX_SLUG && SLUG_VALIDE.test(slug)
  );
}
